import NewsletterCTA from "../components/NewsletterCTA";

const POSTS = [
  {
    title: "RoundUp Cancer: Where Settlements Stand Now",
    date: "Apr 2025",
    excerpt:
      "A quick status update on RoundUp non-Hodgkin’s lymphoma claims, recent verdicts, and what to expect next.",
  },
  {
    title: "Hair Relaxer Lawsuits: Who Qualifies?",
    date: "Apr 2025",
    excerpt:
      "Eligibility checkpoints for uterine/ovarian cancers linked to long-term chemical straightener use.",
  },
  {
    title: "Paraquat & Parkinson’s — New Filings Snapshot",
    date: "Mar 2025",
    excerpt:
      "What recent filings show about exposure patterns and physician documentation that helps claims.",
  },
];

export default function Blog() {
  return (
    <main className="max-w-5xl mx-auto px-4 py-12">
      <header className="mb-8">
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">Blog</h1>
        <p className="mt-2 text-slate-700">
          Insights on investigations, timelines, and legal updates — written in plain English.
        </p>
      </header>

      <div className="grid md:grid-cols-2 gap-6">
        {POSTS.map((p, i) => (
          <article
            key={i}
            className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md transition"
          >
            <div className="text-xs text-slate-500">{p.date}</div>
            <h2 className="mt-1 text-xl font-semibold text-[#0A2540]">{p.title}</h2>
            <p className="mt-2 text-slate-700">{p.excerpt}</p>
            <a
              href="#"
              className="mt-4 inline-block text-[#0A2540] font-semibold hover:underline"
            >
              Read more →
            </a>
          </article>
        ))}
      </div>

      {/* Optional subscribe box */}
      <NewsletterCTA />
    </main>
  );
}
